import { TAG } from "../constants";
import { ReferralCode } from "../types";
import { patientApi } from "./patientApi";

export const referralsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    createReferral: builder.mutation<
      void,
      { email: string; promo_code: string }
    >({
      query: (body) => ({
        url: `/api/patient/refer`,
        method: "POST",
        body,
      }),
    }),
    myReferralCode: builder.query<ReferralCode, void>({
      query: () => ({
        url: `/api/patient/referral-code`,
        method: "GET",
      }),
      providesTags: [TAG.REFERRAL_CODE],
    }),
  }),
});

export const { useCreateReferralMutation, useMyReferralCodeQuery } =
  referralsApi;
